import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dealsHeading:{
        color:'#fe6b02',
        marginLeft:'4vw',
        fontWeight:'700',
        fontSize:'1.8rem',
        fontFamily:'Helvetica'
    },
    dealsCarousel:{
        margin:'6vh 2vw',
        padding:'0vh 1vw',
        marginRight:'0.5%'
    }
}));

export default useStyles;